/** Um sopro, não um timer. Tempo para ler e deixar assentar. */
export const SPARK_WINDOW_MS = 90 * 60 * 1000;
export const SPARK_SHOW_MS = 22 * 1000;
export const SPARK_JOIN_GRACE_MS = 4 * 60 * 1000;
export const SPARK_MAX_PER_VISIT = 3;
export const SPARK_SEEN_KEY = "xpro.voSpark.seenWindow";
export const SPARK_SHOWN_IDS_KEY = "xpro.voSpark.shownIds";

export function unwrapSparks(payload) {
  const root = payload?.data?.data || payload?.data || payload || {};
  const list = Array.isArray(root.sparks) ? root.sparks : Array.isArray(root) ? root : [];
  return list
    .map((row, index) => ({
      id: String(row?.id || `${row?.kind || "spark"}-${index + 1}`),
      kind: String(row?.kind || "notice"),
      hook: String(row?.hook || "").trim(),
      body: String(row?.body || "").trim(),
      nudge: String(row?.nudge || "").trim(),
    }))
    .filter((row) => row.hook && row.body);
}

export function sparkWindowId(now = Date.now(), windowMs = SPARK_WINDOW_MS) {
  const size = Number(windowMs) > 0 ? Number(windowMs) : SPARK_WINDOW_MS;
  return Math.floor(Number(now) / size);
}

export function sparkForWindow(sparks, now = Date.now(), { seenIds = [], windowMs = SPARK_WINDOW_MS } = {}) {
  const list = Array.isArray(sparks) ? sparks.filter((row) => row?.hook && row?.body) : [];
  if (!list.length) return null;
  const seen = new Set((seenIds || []).map(String));
  const fresh = list.filter((row) => !seen.has(String(row.id)));
  if (!fresh.length) return null;
  const pick = fresh[sparkWindowId(now, windowMs) % fresh.length];
  return pick || null;
}

export function shouldRevealSpark({
  joinedAt = 0,
  now = Date.now(),
  lastWindow = null,
  dismissedWindow = null,
  hidden = false,
  shownCount = 0,
  maxPerVisit = SPARK_MAX_PER_VISIT,
  windowMs = SPARK_WINDOW_MS,
  showMs = SPARK_SHOW_MS,
  joinGraceMs = SPARK_JOIN_GRACE_MS,
} = {}) {
  if (hidden) return false;
  if (Number(shownCount) >= Number(maxPerVisit)) return false;
  const ts = Number(now) || Date.now();
  const size = Number(windowMs) > 0 ? Number(windowMs) : SPARK_WINDOW_MS;
  const hold = Number(showMs) > 0 ? Number(showMs) : SPARK_SHOW_MS;
  const grace = Number(joinGraceMs) > 0 ? Number(joinGraceMs) : SPARK_JOIN_GRACE_MS;
  if (Number(joinedAt) > 0 && ts - Number(joinedAt) < grace) return false;
  if (ts % size > hold) return false;
  const win = sparkWindowId(ts, size);
  if (lastWindow === win || dismissedWindow === win) return false;
  return true;
}

export function readSeenSparkWindow(storage) {
  try {
    const raw = storage?.getItem?.(SPARK_SEEN_KEY);
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function writeSeenSparkWindow(storage, windowId) {
  try {
    storage?.setItem?.(SPARK_SEEN_KEY, String(windowId));
    return true;
  } catch {
    return false;
  }
}

export function readShownSparkIds(storage) {
  try {
    const raw = storage?.getItem?.(SPARK_SHOWN_IDS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function writeShownSparkIds(storage, ids) {
  try {
    storage?.setItem?.(SPARK_SHOWN_IDS_KEY, JSON.stringify((ids || []).map(String).slice(0, 12)));
    return true;
  } catch {
    return false;
  }
}

export function sparkEchoCopy(name) {
  const who = String(name || "Alguém").trim().split(/\s+/)[0] || "Alguém";
  return `${who} parou um segundo`;
}
